import { render, staticRenderFns } from "./LeaveAllowanceWrapper.vue?vue&type=template&id=6fe6c13c"
import script from "./LeaveAllowanceWrapper.vue?vue&type=script&lang=js"
export * from "./LeaveAllowanceWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports